<template>
  <v-app id="portal">
    <v-content class="px-2">
      <titulo-responsivo :titulo="locale[local].screen.faleComRH.string001" />
      <v-divider />
      <div v-if="loading" class="d-flex justify-center pt-4">
        <v-card width="1000">
          <v-card-text>
            <v-skeleton-loader
              v-model="loading"
              type="article, article, actions"
            ></v-skeleton-loader>
          </v-card-text>
        </v-card>
      </div>
      <div v-else class="d-flex justify-center pt-4">
        <v-card width="1000">
          <v-card-text>
            <v-row class="mt-2 mx-2">
              <v-col cols="1">
                <v-btn
                  align="left"
                  class="primary"
                  @click="historico"
                  :loading="loadingBtn"
                >
                  <v-icon class="pr-2">mdi-history</v-icon>
                  {{ locale[local].screen.faleComRH.string008 }}
                </v-btn>
              </v-col>
            </v-row>

            <v-row align="center" class="mt-2 mx-2">
              <v-col cols="12">
                <v-select
                  filled
                  :items="items"
                  item-text="descricao"
                  item-value="codTipoAviso"
                  dense
                  :label="locale[local].screen.faleComRH.string002"
                  v-model="itemSelecionado"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  filled
                  v-model="descricao"
                  name="input-7-1"
                  :label="locale[local].screen.faleComRH.string003"
                  :hint="locale[local].screen.faleComRH.string004"
                ></v-textarea>
              </v-col>
              <v-file-input
                v-model="anexo"
                chips
                show-size
                :label="locale[local].screen.faleComRH.string007"
                filled
              >
              </v-file-input>
              <v-col cols="12">
                <v-btn class="primary" @click="enviar" :loading="loadingBtn">
                  <v-icon class="pr-2">mdi-send</v-icon>
                  {{ locale[local].screen.faleComRH.string005 }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
    </v-content>

    <v-dialog v-model="dialogAvisos" outlined elevation="0">
      <v-card-text class="pa-0">
        <v-data-table 
          :headers="headers" 
          :items="items" 
          :items-per-page="30">

            <template v-slot:[`item.dtAviso`]="{ item }">
              {{
                item.dtAviso
                  ? moment(item.dtAviso).format("DD/MM/YYYY")
                  : "Sem data informada"
              }}
            </template>          
        </v-data-table>
      </v-card-text>
    </v-dialog>

  </v-app>
</template>

<script>
import Service from "@/components/api/Service";
import { snackbar } from "cids-cgi/lib/util";
import { locale } from "../locale/locale";

export default {
  data: () => ({
    service: new Service(),
    loading: false,
    loadingBtn: false,
    items: [],
    itemSelecionado: 1,
    descricao: " ",
    anexo: null,
    dialogAvisos: false,

    headers: [
      {
        text: "Empresa",
        value: "codEmp",
        divider: true,
      },
      {
        text: "Empregado",
        value: "codEmpregado",
        divider: true,
      },
      {
        text: "Nome",
        value: "nome",
        divider: true,
      },
      {
        text: "Data",
        value: "dtAviso",
        divider: true,
        custom: true
      },
      {
        text: "Tipo",
        value: "nomeTipoAviso",
        divider: true,
      },
      {
        text: "Descrição",
        value: "descricao",
        divider: true,
      },
      {
        text: "Situação",
        value: "situacao",
        divider: true,
      },
      {
        text: "Retorno RH",
        value: "retornoRh",
      },
    ],
    items: [],    
  }),
  async mounted() {
    this.loading = true;
    try {
      this.items = await this.service.buscaTipoAviso();
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  },

  methods: {
    async enviar() {
      this.loadingBtn = true;

      try {
        await this.service.uploadAnexoFaleComRH(
          this.anexo,
          this.itemSelecionado
        );

        const codTipoAviso = this.itemSelecionado;
        await this.service.gravaAvisoRH(codTipoAviso, this.descricao);
        snackbar.show({
          message: locale[window.local].screen.faleComRH.string006,
          color: "green",
          timeout: 3000,
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.descricao = "";
        this.anexo = null;
      }
      this.loadingBtn = false;
    },
    async historico() {
      this.loadingBtn = true;
      try {
        
        this.items = await this.service.buscaAvisoRH({
          codPessoa: parseInt(localStorage.getItem("codPessoa")),
          dtIniAviso: '1930-01-01',
          dtFimAviso: '2099-01-01',
          situacao: 'T',
        });

        this.dialogAvisos = true;
      } catch (e) {
        this.loadingBtn = false;
      }
      finally{
        this.loadingBtn = false;
      }
    },
  },
};
</script>

 